<div class="container-fluid">
	<!-- month selector -->
	<div class="row">
		<div class="col-md-3">
			<h3 class="text-bold">
				{{ calendar.monthLabel }} {{ calendar.year }}
			</h3>
		</div>
		<div class="col-md-6 text-center">
			<span class="disclaimer text-danger">
				Il SOFTWARE PROPONE 8 ORE PER AGEVOLARE LA COMPILAZIONE MA È RESPONSABILITÀ DELL'AZIENDA INSERIRE LE ORE EFFETTIVE
			</span>
		</div>

		<div class="col-md-3 text-right">
			<button
				type="button"
				class="btn btn-primary mr-2 text-uppercase"
				(click)="today()">
				Oggi
			</button>
			<div
				class="btn-group"
				role="group">
				<button
					type="button"
					class="btn btn-primary py-2"
					(click)="prev()">
					<i class="fas fa-caret-left fa-lg"></i>
				</button>
				<button
					type="button"
					class="btn btn-primary py-2"
					(click)="next()">
					<i class="fas fa-caret-right fa-lg"></i>
				</button>
			</div>
		</div>
	</div>
	<!-- grid -->
	<div class="grid mt-3">
		<!-- header -->
		<div
			class="grid-item py-2 px-1 grid-column-header"
			*ngFor="let d of weekDays">
			<span [ngClass]="{ 'text-danger': d.weekend }">
				<strong>{{ d.label }}</strong>
			</span>
		</div>
		<div
			*ngFor="let d of calendar.days"
			class="grid-item grid-item-cell text-left">
			<div class="grid-item-cell-content position-relative p-2 d-flex align-items-center justify-content-center {{ getCellClasses(d) }}">
				<div
					class="float-left position-absolute"
					style="top:0.25rem; left: 0.5rem;">
					<strong>{{ d.day | date:'dd' }}</strong>
				</div>
				<div *ngIf="d?.workingHours">
					<a
						style="cursor: pointer;"
						(click)="editWokingHours(d)">
						{{ d?.workingHours }} {{ (d?.workingHours > 1 ? ('labels.hours' | translate) : ('labels.hour' | translate)) | lowercase }}
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
